import {gsap} from "gsap";


function TopMenu($) {
  /*
    Desktop Menu
   */
  $('.menu .menu-item.has-expanded-section > a').click(function (e) {
    e.preventDefault();
    let $menu = $(this).closest('.menu');

    // if we are showing then disable all other expanded sections
    if (!$(this).parent().hasClass('expanded')) {
      $('.menu .menu-item.has-expanded-section').removeClass('expanded');
      $(this).parent().addClass('expanded');
      $menu.addClass('expanded');
    } else { // if we are hiding then just hide
      $(this).parent().removeClass('expanded');
      $menu.removeClass('expanded');
    }
  });

  // on clicking outside the menu
  $(document).click(function (e) {
    if (!$(e.target).closest('.menu').length) {
      $('.menu .menu-item.has-expanded-section').removeClass('expanded');
      $('.menu').removeClass('expanded');
    }
  });


  /*
    Mobile Menu
   */

  let Toggle = $(".burger-toggle");
  let TopBar = Toggle.find("b:nth-child(1)");
  let BottomBar = Toggle.find("b:nth-child(3)");



  Toggle.click( function() {
    $(this).toggleClass("active");

    if (Toggle.hasClass("active")) {
      gsap.to(TopBar,{ top: "50%", duration: 1.3, ease: "elastic.out(1,0.3)"});
      gsap.to(BottomBar,{ top: "50%" , duration: 1.3, ease: "elastic.out(1,0.3)"});
      gsap.to(BottomBar, {rotateZ:"90deg", duration: 1, delay: 0.3, ease: "elastic.out(0.7,0.3)" });
      gsap.to(Toggle, {rotateZ:"135deg", duration: 1, delay: 0.3, ease: "elastic.out(0.7,0.3)" });
      $('body').addClass('mobile-menu-active');
    } else {
      gsap.to(Toggle, {rotateZ:"0deg", duration: 1, ease: "elastic.out(0.7,0.3)" });

      gsap.to(BottomBar, {rotateZ:"0deg", duration: 1, ease: "elastic.out(0.7,0.3)" });
      gsap.to(BottomBar, { top: "100%", duration: 0.6, delay:0.25, ease: "elastic.out(0.7,0.3)"});
      gsap.to(TopBar, { top: "0", duration: 0.6, delay:0.25, ease: "elastic.out(0.7,0.3)"});
      $('body').removeClass('mobile-menu-active');
    }
  });

}

export { TopMenu };
